import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EmpresaAppRoutingModule } from "./empresa.app-routing.module"; 

@NgModule({
    imports: [
        CommonModule,     
        EmpresaAppRoutingModule   
    ]
})
export class EmpresaAppModule { }
